import React, { useEffect, useState } from 'react';
import style from './VerticalStepper.style';
import RezRateImg from '../../../../assets/images/header/rezRate.gif';

const VerticalStepper = (props) => {
  const { sections, currentSection, setCurrentSection, DepartmentLogo, isMobile, onSelect } = props;
  const [mySections, setMySections] = useState(sections || []);
  const [myCurrentSection, setMyCurrentSection] = useState(currentSection || {});

  useEffect(() => {
    setMySections(sections);
  }, [sections]);

  useEffect(() => {
    setMyCurrentSection(currentSection);
  }, [currentSection]);

  //   useEffect(() => {
  //     setCurrentSection(myCurrentSection);
  //   }, [myCurrentSection]);

  return (
    <div
      style={{
        ...style.simpleColumn,
        width: isMobile ? '100%' : 300,
        borderRight: isMobile ? null : '2px solid gray',
        height: '75vh',
        justifyContent: 'flex-start',
      }}
    >
      <div style={{ ...style.simpleRow, justifyContent: 'center', marginBottom: 10 }}>
        <img
          src={DepartmentLogo || RezRateImg}
          style={{
            width: 160,
            height: 160,
            objectFit: 'contain',
          }}
        />
      </div>
      <div style={style.simpleRow}>
        <div
          style={{
            ...style.simpleColumn,
            width: '100%',
            // borderRight: '2px solid gray',
            height: 'calc(75vh - 200px)',
            justifyContent: 'flex-start',
          }}
        >
          {mySections.map((section, i) => {
            const { label, icon } = section;
            const isCurrentSection = myCurrentSection ? myCurrentSection.label === label : false;
            return (
              <>
                {i > 0 ? (
                  <div
                    style={{
                      ...style.simpleRow,
                      marginLeft: 44,
                      borderLeft: '3px solid #007bff',
                      height: 15,
                      width: '100%',
                    }}
                  ></div>
                ) : (
                  ''
                )}
                <div
                  style={{ ...style.simpleRow, cursor: 'pointer', width: '100%' }}
                  onClick={() => {
                    setCurrentSection(section);

                    if (onSelect) {
                      onSelect(section);
                    }
                  }}
                >
                  <div
                    style={{
                      ...style.simpleColumn,
                      // width: isCurrentSection ? 58 : 32,
                      // height: isCurrentSection ? 38 : 28,
                      width: 30,
                      height: 30,
                      borderRadius: 50,
                      border: isCurrentSection ? '3px solid #007bff' : '2px solid gray',
                      marginTop: 2,
                      marginBottom: 2,
                      // marginLeft: isCurrentSection ? 0 : 10,
                      marginLeft: 10,
                    }}
                  >
                    {icon ? icon : <div style={{ fontSize: isCurrentSection ? 22 : 18 }}>{i + 1}</div>}
                  </div>
                  <div
                    style={{
                      ...style.simpleColumn,
                      marginLeft: 10,
                      alignItems: 'flex-start',
                      // fontSize: isCurrentSection ? 18 : 15,
                      fontSize: 15,
                      fontWeight: isCurrentSection ? 'bold' : null,
                      color: isCurrentSection ? '#007bff' : 'gray',
                    }}
                  >
                    {label}
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default VerticalStepper;
